import Card from '@Utils/Card';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Modal, Popover, Spin, Table, Tooltip } from 'antd';
import {
  InfoCircleFilled,
  LoadingOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import styles from './telegramBotLists.module.less';
import UpdateModalContent from './updateModalContent';

function TooltipContent(props) {
  if (props.loading) {
    return (
      <div>
        <Spin indicator={<LoadingOutlined spin style={{ color: '#fff' }} />} />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <span>Firstname: {props.info?.firstName || '-'}</span>
      <span>Lastname: {props.info?.lastName || '-'}</span>
      <span>Username: {props.info?.username || '-'}</span>
    </div>
  );
}

function PopoverContent(props) {
  return (
    <div className={styles.popover_actions}>
      <div
        onClick={props.onUpdate}
        className={styles.popover_item}
        style={{
          ...(props.updating && { opacity: 0.3, pointerEvents: 'none' }),
        }}
      >
        <Spin
          spinning={props.updating}
          indicator={<LoadingOutlined spin style={{ color: '#000' }} />}
        />
        <span>Edit</span>
      </div>
      <div
        onClick={props.onDelete}
        className={styles.popover_item}
        style={{
          ...(props.deleting && { opacity: 0.3, pointerEvents: 'none' }),
        }}
      >
        <Spin
          spinning={props.deleting}
          indicator={<LoadingOutlined spin style={{ color: '#000' }} />}
        />
        <span>Delete</span>
      </div>
    </div>
  );
}

function TelegramBotLists(props) {
  const [updatingId, setUpdatingId] = useState(null);

  useEffect(() => {
    props.telegramChannelListFetch();
  }, []);

  const columns = useMemo(
    () => [
      {
        title: 'bot name',
        dataIndex: 'id',
        key: 'id',
        render: () => 'Telegram',
      },
      {
        title: 'configuration name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'information',
        dataIndex: 'id',
        align: 'center',
        key: 'id',
        render: (id) => (
          <Tooltip
            onOpenChange={(visible) => {
              if (visible) {
                props.telegramChannelInfoFetch(id);
              }
            }}
            trigger="click"
            placement="top"
            title={
              <TooltipContent info={props.info} loading={props.loadingInfo} />
            }
            overlayInnerStyle={{ background: '#1d88f6' }}
            arrowPointAtCenter
          >
            <InfoCircleFilled style={{ fontSize: 24, color: '#1d88f6' }} />
          </Tooltip>
        ),
      },
      {
        title: 'actions',
        dataIndex: 'id',
        align: 'center',
        width: 80,
        key: 'id',
        render: (id) => (
          <Popover
            placement="leftTop"
            showArrow={false}
            content={
              <PopoverContent
                updating={props.updating}
                deleting={props.deleting}
                onDelete={() => props.telegramChannelDeleteFetch(id)}
                onUpdate={() => {
                  props.telegramChannelViewFetch(id);
                  setUpdatingId(id);
                }}
              />
            }
          >
            <div className={styles.action}>
              <MoreOutlined />
            </div>
          </Popover>
        ),
      },
    ],
    [props]
  );

  return (
    <Fragment>
      <Card>
        <div className={styles.title}>
          <span>Your Telegram Bot Name</span>
        </div>
        <div className={styles.content}>
          <Table
            loading={props.loading}
            columns={columns}
            dataSource={props.page?.content || []}
            pagination={false}
          />
        </div>
      </Card>

      <Modal
        title="Update Configuration"
        centered
        destroyOnClose
        footer={null}
        open={updatingId !== null}
        onCancel={() => setUpdatingId(null)}
      >
        <UpdateModalContent
          view={props?.view}
          updating={props.updating}
          retrievingData={props.retrievingData}
          onCancel={() => setUpdatingId(null)}
          onUpdate={(values) => {
            if (updatingId) {
              props.telegramChannelUpdateFetch(updatingId, values, () =>
                setUpdatingId(null)
              );
            }
          }}
        />
      </Modal>
    </Fragment>
  );
}

export default TelegramBotLists;
